import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/** items: [{ to, label }], last item = current page (no link). */
export function Breadcrumb({ items }) {
  return (
    <nav aria-label="Fil d'Ariane" data-testid="collection-breadcrumb" className="mb-6">
      <ol className="flex flex-wrap items-center gap-2 text-xs uppercase tracking-[0.2em] text-[var(--parchment)]/70">
        {items.map((it, i) => (
          <li key={it.label} className="flex items-center gap-2">
            {i > 0 ? <ChevronRight className="h-3 w-3" aria-hidden="true" /> : null}
            {i < items.length - 1
              ? <Link to={it.to} data-testid={`breadcrumb-${i}`} className="hover:text-[var(--gold-soft)]">{it.label}</Link>
              : <span aria-current="page" className="text-[var(--gold)]">{it.label}</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export const breadcrumbLd = (site, items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.label, item: `${site}${it.to}` })),
});
